import { withTranslation } from "next-i18next";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";
import LowResultsProductSliderGallery from "./LowResultsProductSliderGallery";
import catalogContexts from "@utils/constants/catalogContexts";

function LowResultsProductSlider({ context, products, uiState, t }) {
  const user = useCurrentUser();
  const userTagMaternity = user?.user_tags?.find((tag) => tag.key === "maternity")?.value || false;
  const title = t(
    context === catalogContexts.sales
      ? "catalog:low_results_section.top_sales.title"
      : "catalog:low_results_section.newest.title",
  );

  function findRedirectionPath() {
    switch (context) {
      case catalogContexts.swap:
      case catalogContexts.userlist:
        if (userTagMaternity) return t("catalog:low_results_section.maternity.path");

        return t("catalog:low_results_section.newest.path");
      case catalogContexts.sales:
        return t("catalog:low_results_section.top_sales.path");
      default:
        return t("catalog:low_results_section.newest.path");
    }
  }

  if (!products?.length || products?.length <= 4) return null;

  return (
    <section className="low-results-product-slider-section">
      <div className="low-results-product-slider-section-container">
        <div className="text-center px-3">
          <h4>{title}</h4>
        </div>
        <Link
          href={findRedirectionPath()}
          className="low-results-product-slider-section-header-link"
        >
          {t("catalog:low_results_section.see_more")}
        </Link>
        <LowResultsProductSliderGallery
          context={context}
          products={products}
          uiState={uiState}
        />
      </div>
    </section>
  );
}

export default withTranslation("catalog")(LowResultsProductSlider);
